import PatientCreate from 'dashboard/templates/views/Patient/Create/PatientCreate';
import store from 'dashboard/store';

export default {
    path: 'patients/create',
    component: PatientCreate,
    name: 'PatientCreate',
    meta: {
        // title: 'Create Patient',
        title: t => t('patient.create'),
        loggedInOnly: true
    },
    beforeEnter(to, from, next) {
        // Remove previous imported patient data before entering
        store.commit('newPatient/reset');

        next();
    },
};
